<template>
  <div class="tw-flex tw-flex-col tw-h-full tw-min-h-screen">
    <wizard-steps></wizard-steps>
    <div class="tw-flex tw-flex-col tw-flex-grow paddings-mobile-wizard lg:tw-justify-center lg:tw-mt-0 tw-mt-40">
      <router-view></router-view>
    </div>
    <div></div>
    <div class="footer-wizard" :class="{ showing: showingMobile }">
      <div class="grey-container">
        <div class="tw-text-container tw-flex tw-items-center">
          <span class="tw-text-center"
            >“Todos estos datos serán tratados de una manera privada y solo serán usados para una valoración de la vivienda. Una vez cerrado el trato borraremos estos datos.”</span
          >
        </div>
      </div>
      <div class="footer-reduced" :class="{ showing: showingMobile }">
        <div>
          <span class="tw-text-base">Inverpriban RENT 2022</span>
        </div>
        <div>
          <a href="/legalidad" class="tw-mr-6 tw-text-base">Aviso legal</a>
          <a href="/politica-de-privacidad" class="tw-mr-6 tw-text-base"
            >Política de privacidad</a
          >
          <a href="/politica-de-cookies" class="tw-text-base">Cookies</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WizardContent from "./wizard/WizardContent";
import WizardSteps from "./wizard/WizardSteps";

export default {
  components: {
    WizardContent,
    WizardSteps,
  },
  computed: {
    showingMobile() {
      return this.$route.name == "personalForm" ? true : false;
    },
  },
};
</script>

<style lang="scss">
@import "../../sass/variables";
.footer-wizard {
  display: flex;
  flex-direction: column;

  .grey-container {
    display: flex;
    justify-content: space-between;
    padding: 25px 100px;
    background-color: #f2f3f4;
    bottom: 0px;
    @media(max-width: 992px){

      flex-direction: column;
      padding: 2rem 1rem 115px 1rem;
    }
  }

  @media (max-width: 992px) {
    position: relative;
    display: none;

    &.showing {
      display: flex;
    }
  }

  .text-container {
    width: 60%;
    @media (max-width: 992px) {
      width: 100%;
      span {
        font-size: 12px;
      }
    }
  }
  .logo-container {
    margin-left: 1.5rem;
  }
}

.footer-reduced {
  display: flex;
  justify-content: space-between;
  padding: 10px 100px;
  background-color: $color-black;

  @media(max-width:992px){
    display: none;
  }

  a,
  span {
    font-size: 12px;
    color: white;
  }
}
</style>
